import api from '../lib/api';


export const LOGIN = 'LOGIN';
export const LOGGEDIN = 'LOGGEDIN';
export const LOGOUT = 'LOGOUT';

/** actions */

export const resetPassword = ({password, password_confirmation}, cb) => (dispatch) => {
  const q = new URLSearchParams(window.location.search);
  const email = q.get('email') || '';

  const data = {
    dob: q.get('dob'),
    email: email.replace(' ', '+'),
    password,
    password_confirmation,
    token: q.get('t')
};
    api.reset(data, cb);
};
